import { render, staticRenderFns } from "./StaffAutoSuggest.vue?vue&type=template&id=37cc4442"
import script from "./StaffAutoSuggest.vue?vue&type=script&lang=js"
export * from "./StaffAutoSuggest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports